<template>
  <div  :class="[{ 'fullscreen-layout': isFull }]">
<!-- 建筑 都放在下边   background-color: bisque;-->
  <!-- <div style="width:100%; height: 100%;">
    <div style="text-align: right ; margin-right: 5px;" >
      <el-button @click="fullScreen" v-if="!isFull" type="primary" >全 屏</el-button>
      <el-button @click="normalScreen" v-else type="primary" >关闭页面</el-button>
    </div> -->

    <div>
      
      <el-row>

        <el-col :span="22" style="margin-top: 20px">
          <!-- 顶部导航处 -->
          <el-row >
            <el-col :span="10" >
              <span style="padding-right: 10px;">课程:</span>
              <el-button 
                    v-for="(item, index) in courseList" 
                    :key="index"
                    style="margin: 1px;"
                    :class="{ 'active': course == item, 'normal': course != item }"
                    @click="checkCourse(item)"
                  >
                    {{ item.name }}
                  </el-button>
            </el-col>

            <el-col :span="8" v-if="course != null && hardClassList.length != 0">
              <span style="padding-right: 10px;">班级:</span>
              <el-button 
                    v-for="(item, index) in hardClassList" 
                    :key="index"
                    :class="{ 'active': hard.hard_name == item.hard_name, 'normal': hard.hard_name != item.hard_name }"
                    @click="checkHardClass(item)"
                  >
                    {{ item.hard_name }}
                  </el-button>
            </el-col>

            <el-col :span="6">
              <span> 考试列表 </span>

            </el-col>
          </el-row>

          <!-- 图表内容处 -->
           <!-- <el-button @click="loadExamCtrl">TEST</el-button> -->

           <div ref="chart" style="width: 100%; height: 1000px;" v-if="checkChart == 'indicatorCompare' || checkChart == 'step10Compare'  "></div>

           <div ref="chart" style="width: 100%; height: 2000px;" v-if=" checkChart == 'scoreStatistics'"></div>


           <!-- :header-cell-style="{ textAlign: 'center' }" -->
           <el-table :data="tableData" :row-style="rowStyle" v-if="checkChart == 'kgStatistics' "  :cell-style="{ textAlign: 'center' }"  style="margin-top: 25px">
              <el-table-column prop="name" label="题序" width="120px">
                <template slot-scope='scope'>
                  <span class="label">第 {{ scope.row.ix }} 题</span>
                </template>
              </el-table-column>
              <el-table-column :label= tableName >
                <template slot-scope='scope'>
                  <!-- <div v-for="(item, index) in scope.row.answers" :key="index">
                      {{ key }}: {{ value }}
                  </div> -->
                  <div v-for="(item, index) in scope.row.answers" :key="index"  class="progress-row">
                    <span class="label">{{ item.anw }}:</span>
                    <el-progress
                      :percentage="item.count" 
                      :format="() => `${item.count}个`"
                      :text-inside="flase"
                      :stroke-width="15" 
                      style="width: 80%"
                    ></el-progress>
                  </div>

                </template>
              </el-table-column>

          </el-table>

        </el-col>

        <el-col :span="2">
          <el-card style="height: 100vh;background-color: #f0f2f5; ">
            <div class="button-container">
              <el-button 
                  v-for="(item, index) in chartType" 
                  :key="index"
                  type="primary"
                  @click="chartTypeShow(item)"
                >
                  {{ item.name }}
                </el-button>

            </div>
          </el-card>
        </el-col>
        
      </el-row>
    </div>





    </div>

</template>

<script>
  import {mapGetters, mapState} from "vuex";
  import * as simpleApi from "request/simple";
  import XEUtils from 'xe-utils'
  import * as mUtils from '@/utils/mUtils'
  import * as echarts  from 'echarts';

  export default {
      name: 'teacherDialog',
      data(){
          return {
            isFull: true,
            hardClassList:[],
            hardClassList2:["23动漫2班", "23珠宝班","23设计2班","23设计3班"],
            // courseList:["形式政策"],
            courseList:[],
            // 图表类型
            chartType: [{
              type: 'indicatorCompare',
              name:"各类指标比对表"
            },{
              type: 'step10Compare',
              name:"分数段比较表"
            },{
              type: 'kgStatistics',
              name:"客观题统计表"
            },{
              type: 'scoreStatistics',
              name:"得分率比较表"
            }],
            scoreRange: ['优秀','良好','中等','及格','不及格'], 
            scoreLevels: {
              score90: {name: '优秀', from: 90, to: 100}, 
              score80: {name: '良好', from: 80, to: 90},
              score70: {name: '中等', from: 70, to: 80},
              score60: {name: '及格', from: 60, to: 70}, 
              score0: {name: '不及格', from: 0, to: 60},
            },
            jsonData: null,
            // 班级统计信息
            hardClassStatistics: null,
            // 选中课程
            course: null,
            // 选中班级
            hard: {
              hardName: null,
              index: 0
            },
            step10List:[],
            tableData2:[],
            tableData: [
              { 
                name: '华北地区', 
                sales: [
                  { name: '产品A', value: 150 },
                  { name: '产品B', value: 200 },
                  { name: '产品C', value: 120 }
                ]
              },
              { 
                name: '华东地区', 
                sales: [
                  { name: '产品A', value: 180 },
                  { name: '产品B', value: 160 },
                  { name: '产品C', value: 140 }
                ]
              }
            ],
            test:[{
              anw: 'A',
              count:5
            },{
              anw: 'B',
              count:1
            },{
              anw: 'C',
              count:0
            },{
              anw: 'D',
              count:9
            },],
            // 选中图表
            checkChart: null,
            tableName: null,
            jsonHardData: null

          }
      },
      components:{
      },
      computed:{
          ...mapState({
              userInfo: state => state.user.userInfo,
          }),
      },
      mounted() {
       
      },
      props: {

      },
      watch: {
         
      },
      created(){
        this.loadCourceList()
       },
      methods: {
        // 全屏显示
        fullScreen(){
          this.isFull = true
        },
        // 普通显示
        normalScreen(){
          this.isFull = false
        },
        // 获取analyse.json并解析
        loadExamCtrl(analyse_oss_name, callback){
          analyse_oss_name = "answer/analyse/310/exam_analyse_310.json"
          // analyse_oss_name = "answer/analyse/2883/exam_analyse_2883.json"
          if(analyse_oss_name != null){
              analyse_oss_name = window.g.OSS_HOST + analyse_oss_name;
          }
          this.loading = true;
          let that = this;
          axios.defaults.headers = {'Content-Type': 'application/json;charset=UTF-8'}
          axios({
              method:'get',
              url: `${analyse_oss_name}?t=${Date.now()}`
            }).then((res)=>{
                this.jsonData = res.data
                let data = res.data;
                // 年段平均分
                // let gradeAvg = data.score_avg
                
                // 年段总分
                let gradeFullScore = data.full_score
                // 每个班级各分数段列表(平均，优秀...)
                let hard_score_count = data.hard_score_count
                // 每个班级统计数据（包含最高分，最低分，各分数段等）
                let hard_scores =data.hard_scores

                // 整合分数框架
                this.getScoreLevels(gradeFullScore)
                // 根据总分，10分一阶段
                this.getStep10List(gradeFullScore)

                this.getInfo(hard_scores)

                // this.tableData = data.scores

                this.loadingTiJson()
                if(callback) callback()
                else that.loading = false;
            }).catch((error) => {
                that.loading = false;
            });

        },
        // 计算
        getInfo(hardScores){
       
          // 针对每个班级整合统计信息
          let hardClass = []
          hardScores.forEach((item,index) => {

            // 获取班级信息
            let hardName = item['hardName']
            hardClass.push({
              hardName: hardName,
              index: index
            })
            // 根据获得每个等级的人数
            let scores = item.scores
            let level = this.getScoreNums(item)
            item.scoreLevels = level

          });

          this.hardClassList = hardClass

          this.hardClassStatistics = hardScores
        },
        // 利用总分算30%的区间
        getScoreLevels(totalScore){
          // 基础框架
          let scoreForm = this.scoreLevels;
          scoreForm.score0.from = 0
          scoreForm.score0.to = Math.ceil(totalScore*0.6)
          scoreForm.score60.from = Math.ceil(totalScore*0.6)
          scoreForm.score60.to = Math.ceil(totalScore*0.7)
          scoreForm.score70.from = Math.ceil(totalScore*0.7)
          scoreForm.score70.to = Math.ceil(totalScore*0.8)
          scoreForm.score80.from = Math.ceil(totalScore*0.8)
          scoreForm.score80.to = Math.ceil(totalScore*0.9)
          scoreForm.score90.from = Math.ceil(totalScore*0.9)
          scoreForm.score90.to = totalScore+1
        },
        getStep10List(totalScore) {

          let size = 10
          let segments = [];
          for (let i = 0; i < totalScore; i += size) {
            let start = i;
            let end = i + size;
            segments.push(`${start}-${end}`);
          }
          this.step10List = segments
        },
        getScoreNums(item){
          let scoreLevels = this.scoreLevels 
          let scores = item.scores
          let level = []
          Object.keys(scoreLevels).forEach(key => {
              // console.log('键:', key);
              // console.log('值:', scoreLevels[key]);
              let form = scoreLevels[key].from
              let to = scoreLevels[key].to
              let count = 0
              scores.forEach(ele => {
                if(ele.score >= form && ele.score < to){
                  count = count + ele.count;
                }
              });
              // 每个等级的人数（当前班级）
              let param = Object.assign({}, scoreLevels[key]);
              param.count = count
              level.push(param)
          });
          return level


        },
        // 选中课程
        checkCourse(value){
          this.course = value
          // 选中课程后  查询该老师该课程下的行政班列表
          this.loadMyClassList()



          // this.loadExamCtrl()
        },
        checkHardClass(value){
          this.hard = value
        },
        chartTypeShow(item){
          let chartName = item.type
          this.checkChart = chartName
          if(chartName == 'indicatorCompare'){
            this.indicatorChart()
          }else if(chartName == 'step10Compare'){
            this.step10Chart()
          }else if(chartName == 'kgStatistics'){
            this.kgChart()
          }else if(chartName == 'scoreStatistics'){
            this.scoreStatisticsChart()
          }
        },
        indicatorChart() {
          // 获取当前选中的班级
          let index = this.hard.index
          let legendHard = this.hard.hardName + "指标"
          let hardClass = this.hardClassStatistics[index].scoreLevels
          let scoreRange = this.scoreRange
          let gradeScoreLevel = this.jsonData.score_level

          // 根据顺序排列值
          let hardClassSort2 = hardClass.sort((x, y) => {
            return scoreRange.indexOf(x.name) - scoreRange.indexOf(y.name)
           
          });
          let hardClassSort = hardClass.sort((x, y) => 
              scoreRange.indexOf(x.name) - scoreRange.indexOf(y.name)
            ).map(item => item.count)

          console.log("排序",hardClassSort);

          
          let gradeSort2 = gradeScoreLevel.sort((x, y) => {
            return scoreRange.indexOf(x.name) - scoreRange.indexOf(y.name)
          });
          let gradeSort = gradeScoreLevel.sort((x, y) => 
              scoreRange.indexOf(x.name) - scoreRange.indexOf(y.name)
            ).map(item => item.count)
          


          // 初始化图表实例
          this.chart = echarts.init(this.$refs.chart);
          
          // 配置项
          let option = {
            title: {
              text: this.hard.hardName + '各类指标比对',  // 主标题
              // subtext: '2 Data'                 // 副标题
            },
            // 触发方式：'axis'坐标轴触发，'item'数据项触发
            tooltip: {
              trigger: 'axis'  
            },
            // X轴配置
            xAxis: [
              {
                // 类目轴，适用于离散的类目数据
                type: 'category',  
                // 配置X轴名称
                data: this.scoreRange
              }
            ],
            // Y轴配置
            yAxis: [
              {
                // 数值轴，适用于连续数据
                type: 'value'  
              }
            ],
            // 图例项，对应series中的name
            legend: {
              data: [legendHard, '年段指标']  
            },
            // 数值列表
            series: [
              {
                // 系列名称，与legend对应
                name: legendHard,
                // 图表类型：柱状图
                type: 'bar', 
                // 数据数组 
                data: hardClassSort,
                itemStyle: {
                  color: '#90cbfb'
                },
                barGap: '10%', 
              },{
                  name: '年段指标',      
                  type: 'bar',           
                  data: gradeSort, 
                  itemStyle: {
                    color: '#d2e682'
                  },
                  barGap: '10%', 
              }
            ]
          }
          // 设置配置项并渲染
          this.chart.setOption(option);
        },
        step10Chart(){
          // 获取当前选中的班级
          let index = this.hard.index
          let legendHard = this.hard.hardName + "分数段"
          let hardStep10 = this.hardClassStatistics[index].step10
          let gradeStep10 = this.jsonData.score_step10

          // 过滤排序
          let hardClassSort = hardStep10.map(item => item.count)
          let gradeSort  = gradeStep10.map(item => item.count)

          // 初始化图表实例
          this.chart = echarts.init(this.$refs.chart);
          
          // 配置项
          let option = {
            title: {
              text: this.hard.hardName + '各类指标比对',  
            },
            // 触发方式：'axis'坐标轴触发，'item'数据项触发
            tooltip: {
              trigger: 'axis'  
            },
            // X轴配置
            xAxis: [
              {
                // 类目轴，适用于离散的类目数据
                type: 'category',  
                // 配置X轴名称
                data: this.step10List
              }
            ],
            // Y轴配置
            yAxis: [
              {
                // 数值轴，适用于连续数据
                type: 'value'  
              }
            ],
            // 图例项，对应series中的name
            legend: {
              data: [legendHard, '年级分数段']  
            },
            // 数值列表
            series: [
              {
                // 系列名称，与legend对应
                name: legendHard,
                // 图表类型：柱状图
                type: 'bar', 
                // 数据数组 
                data: hardClassSort,
                itemStyle: {
                  color: '#90cbfb'
                },
                barGap: '10%', 
              },{
                  name: '年级分数段',      
                  type: 'bar',           
                  data: gradeSort, 
                  itemStyle: {
                    color: '#d2e682'
                  },
                  barGap: '10%', 
              }
            ]
          }
          // 设置配置项并渲染
          this.chart.setOption(option);


        },
        loadingTiJson(){
          // 解读json
          let analyse_oss_name = "answer/analyse/310/exam_hard_ti_310.json"
          // let analyse_oss_name = "answer/analyse/2883/exam_hard_ti_2883.json"
          if(analyse_oss_name != null){
              analyse_oss_name = window.g.OSS_HOST + analyse_oss_name;
          }
          this.loading = true;
          // let that = this;
          axios.defaults.headers = {'Content-Type': 'application/json;charset=UTF-8'}
          axios({
              method:'get',
              url: `${analyse_oss_name}?t=${Date.now()}`
            }).then((res)=>{

              this.jsonHardData =  res.data

            })
        },

        kgChart(){
          
          // 解读json
          // let analyse_oss_name = "answer/analyse/310/exam_hard_ti_310.json"
          //  let analyse_oss_name = "answer/analyse/2883/exam_hard_ti_2883.json"
          // if(analyse_oss_name != null){
          //     analyse_oss_name = window.g.OSS_HOST + analyse_oss_name;
          // }
          // this.loading = true;
          // // let that = this;
          // axios.defaults.headers = {'Content-Type': 'application/json;charset=UTF-8'}
          // axios({
          //     method:'get',
          //     url: `${analyse_oss_name}?t=${Date.now()}`
          //   }).then((res)=>{
  
              // 过滤单选多选的题目
              let hardJson = this.jsonHardData 
              // this.jsonHardData =  res.data

              this.tableName = this.hard.hardName + "统计情况"
              // 筛选出单多选题
              let data  = hardJson[this.hard.hardName]
              // .filter(item => item.t1 == 'SingleChoice' || item.t1 == 'SingleChoice')
              

              const result = data
                .filter(item => item.t1 === "SingleChoice" || item.ti === 'MultipleChoice')
                .map(item => ({
                    ...item,
                    answers: Object.keys(item)
                        .filter(key => !['ix', 't1', 't2','score_rate'].includes(key))
                        .map(key => ({ anw: key, count: item[key] }))
                        .sort((a, b) => a.anw.localeCompare(b.anw))  // 按字母排序
                }));

                this.tableData = result


            // })
        },
        scoreStatisticsChart(){

          // 筛选出单多选题
          let data  = this.jsonHardData[this.hard.hardName]
          // .filter(item => item.t1 == 'SingleChoice' || item.t1 == 'SingleChoice')
          

          let hard_score_rate = data
                .filter(item => item.t1 === "SingleChoice" || item.ti === 'MultipleChoice')
                .map(item => item.score_rate)
                .reverse();
          
          let ti_list = data
                    .filter(item => item.t1 === "SingleChoice" || item.ti === 'MultipleChoice')
                    .map(item => '第' + item.ix + '题')
                    .reverse();
          let scores = this.jsonData.scores.filter(item => item.type =="SingleChoice" || item.type =="MultipleChoice" )
          let join_count = this.jsonData.join_count
          let result = scores.map(item => {
           
            let right_anw = item.right_anw
            let score = item.right_score
            // 过滤正确答案的人数
            let anw = item.anw_count.filter(i => i.anw == right_anw)[0]['count']
            // return anw / join_count;
            return  Math.round(anw / join_count * 100) / 100;
          }).reverse();

          // 初始化图表实例
          this.chart = echarts.init(this.$refs.chart);
                    
            // 配置项
            let option = {
              title: {
                text: this.hard.hardName  ,  
              },
              // 触发方式：'axis'坐标轴触发，'item'数据项触发
              tooltip: {
                trigger: 'axis'  
              },
              // X轴配置
              yAxis: [
                {
                  // 类目轴，适用于离散的类目数据
                  type: 'category',  
                  // 配置X轴名称
                  data: ti_list
                }
              ],
              // Y轴配置
              xAxis: [
                {
                  // 数值轴，适用于连续数据
                  type: 'value'  
                }
              ],
              // 图例项，对应series中的name
              legend: {
                data: ["班级", '年级']  
              },
              // 数值列表
              series: [
                {
                  // 系列名称，与legend对应
                  name: "班级",
                  // 图表类型：柱状图
                  type: 'bar', 
                  // 数据数组 
                  data: hard_score_rate,
                  itemStyle: {
                    color: '#90cbfb'
                  },
                  barGap: '10%', 
                },{
                    name: '年级',      
                    type: 'bar',           
                    data: result, 
                    itemStyle: {
                      color: '#ff8924'
                    },
                    barGap: '10%', 
                }
              ]
            }
            // 设置配置项并渲染
            this.chart.setOption(option);



        },
        // 总结归纳下班级的值    
        getHardScoreData(sht, ck){

            this.scoreRange = [{name: "优秀", from: 90, to: 100}, {name: "及格", from: 60, to: 100},{name: "不及格", from: 0, to: 60}];
            let hardScores = this.jsonData.hard_scores;
            let fullScore = this.jsonData.full_score;
            this.hardClassList.forEach((hardName,index) =>{
     
              let fi = XEUtils.findIndexOf(hardScores, item => item.hardName==hardName);
              if(fi > -1){
                let h = hardScores[fi];
                sht.real.push(h.count);
                sht.total.push(h.totalScore);
                sht.avg.push( (h.totalScore/h.count).toFixed(2));
                sht.min.push(h.min);
                sht.max.push(h.max);
                sht.level10.push(h.step10);
                let ran = [];
                // scoreRange： 统计优秀，及格，不及格人数
                for (let j=0; j<this.scoreRange.length;j++){
     
                  let sr = this.scoreRange[j];
                  let mcount = 0;
                  let myTo = (sr.to==fullScore)?(sr.to+1):sr.to;
                  XEUtils.arrayEach(h.scores, (item, key) => {
                    if(item.score >= sr.from && item.score < myTo){
                      mcount = mcount + item.count;
                    }
                  })
                  ran.push({name: sr.name, count: mcount, lv: (mcount/h.count).toFixed(4)});
                }
                sht.range.push(ran);
              }

            })

            

        },
        // 区分优秀，及格，不及格等（利用总分算30%的区间）
        setScoreLevel(scoreCount,totalScore){
            let scoreForm = this.scoreLevels;
            // console.log("setScoreLevel", scoreForm)
            // let scoreCount = this.jsonData.score_count
            // let totalScore = this.examInfo.totalScore
            scoreForm.score0.from = 0
            scoreForm.score0.to = Math.ceil(totalScore*0.6)
            scoreForm.score60.from = Math.ceil(totalScore*0.6)
            scoreForm.score60.to = Math.ceil(totalScore*0.7)
            scoreForm.score70.from = Math.ceil(totalScore*0.7)
            scoreForm.score70.to = Math.ceil(totalScore*0.8)
            scoreForm.score80.from = Math.ceil(totalScore*0.8)
            scoreForm.score80.to = Math.ceil(totalScore*0.9)
            scoreForm.score90.from = Math.ceil(totalScore*0.9)
            scoreForm.score90.to = totalScore+1
            let list = scoreCount.score;
            let good90 = {name: "优秀(" + scoreForm.score90.from + "-" + scoreForm.score90.to + ")", count: 0};
            let good80 = {name: "良好(" + scoreForm.score80.from + "-" + scoreForm.score80.to + ")", count: 0};
            let good70 = {name: "中等(" + scoreForm.score70.from + "-" + scoreForm.score70.to + ")", count: 0};
            let good60 = {name: "及格(" + scoreForm.score60.from + "-" + scoreForm.score60.to + ")", count: 0};
            let good0 = {name: "不及格(" + scoreForm.score0.from + "-" + scoreForm.score0.to + ")", count: 0};
            let good_count = 0, up_count = 0, total_count = 0;

            for (let i=0; i< list.length; i++){
                let d = list[i];
                if(d >=scoreForm.score0.from && d < scoreForm.score0.to){
                    good0.count = good0.count + scoreCount.count[i];
                    good0.name = "不及格(" + scoreForm.score0.from + "-" + scoreForm.score0.to + ")";
                    total_count = total_count + scoreCount.count[i];
                }
                if(d >=scoreForm.score0.to && d < scoreForm.score60.to){
                    good60.count = good60.count + scoreCount.count[i];
                    good60.name = "及格(" + scoreForm.score60.from + "-" + scoreForm.score60.to + ")";
                    up_count = up_count + scoreCount.count[i];
                    total_count = total_count + scoreCount.count[i];
                }
                if(d >=scoreForm.score60.to && d < scoreForm.score70.to){
                    good70.count = good70.count + scoreCount.count[i];
                    good70.name = "中等(" + scoreForm.score70.from + "-" + scoreForm.score70.to + ")";
                    up_count = up_count + scoreCount.count[i];
                    total_count = total_count + scoreCount.count[i];
                }
                if(d >=scoreForm.score70.to && d < scoreForm.score80.to) {
                    good80.count = good80.count + scoreCount.count[i];
                    good80.name = "良好(" + scoreForm.score80.from + "-" + scoreForm.score80.to + ")";
                    up_count = up_count + scoreCount.count[i];
                    total_count = total_count + scoreCount.count[i];
                }
                if(d >=scoreForm.score80.to ) {
                    good90.count = good90.count + scoreCount.count[i];
                    good90.name = "优秀(" + scoreForm.score90.from + "-" + scoreForm.score90.to + ")";
                    up_count = up_count + scoreCount.count[i];
                    good_count = good_count + scoreCount.count[i];
                    total_count = total_count + scoreCount.count[i];
                }
            }
            // this.examCount.goodScale = Math.round(good_count/total_count *10000 )/100 ;
            // this.examCount.upScale = Math.round(up_count/total_count*10000)/100;
            // let levelList = [good90, good80, good70, good60, good0];
            // console.log("levelList", levelList)
            // this.setScoreLevelData(levelList);
        },
        rowStyle({ row, rowIndex }) {
          return {
            height: '100px'  // 设置行高
          }
        },
        // 读取教师的所属课程
        loadCourceList(){
          
            let search = {  licenceId: this.userInfo.licenceId, schoolId: mUtils.searchText(this.userInfo.schoolId)};
            let param = { controllerName: 'sclCource', methodName: '/listAll',param: search};
            return simpleApi.list(param).then(({result: {code, data}}) =>  {
                if (code == 0) {
                 this.courseList = data
                }
            }).catch((error) => {
                console.log("error",error)
            });
        },
        // 读取老师旗下指定课程的行政班列表
        loadMyClassList(){
          // debugger
          let courseId = this.course.id
            let search = {  teacherId: this.userInfo.id,courseId: courseId};
            let param = { controllerName: 'teacherMyClass', methodName: '/myClassListAll',  param: search};
            return simpleApi.list(param).then(({result: {code, data}}) =>  {
              if (code == 0) {
                this.hardClassList = data
              }
            }).catch((error) => {
                console.log("error",error)
            });
        },


    }
  }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">

.fullscreen-layout {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999; /* 确保在最上层 */
  background: #fff; /* 或其他背景色 */
  overflow: auto;
}

.button-container {
  display: flex;
  flex-direction: column;
  align-items: center; /* 让所有按钮水平居中 */
  gap: 30px; /* 按钮间距 */
  padding: 20px 0; /* 上下内边距 */
  justify-content: center;
}

.normal {
  background: #f0f0f0;
  color: #333;
}

.active {
  background: #007bff;
  color: white;
  border-color: #0056b3;
  box-shadow: 0 2px 5px rgba(0,123,255,0.3);
}

.progress-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.label {
  // margin-right: 10px;
  min-width: 20px;
}

.progress-bar {
  flex: 1;
}


</style>


